import { ThemeUIStyleObject } from 'theme-ui';
import { useCart } from '@chordcommerce/react-autonomy';
import { getAllCartPromotionsForDisplay } from '~/utils/promotions';
import { useTranslate } from '~/hooks/utils/use-translate';
import RedemptionForm from '~/components/Generic/Form/RedemptionForm';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import ToggleButton from '../Summary/ToggleButton';

type Props = {
  forwardSx?: ThemeUIStyleObject;
};

const PromoCode = ({ forwardSx }: Props) => {
  const translate = useTranslate();
  const [showPromoCode, setShowPromoCode] = useState(true);
  const { cart, addPromoCode } = useCart();
  const promotions = getAllCartPromotionsForDisplay(cart);

  const handleSubmit = async (code: string) => {
    await addPromoCode({ promoCode: code });
    setShowPromoCode(false);
  };

  const getErrorMessage = (error: string) => {
    switch (error) {
      case "The coupon code you entered doesn't exist. Please try again.":
        return translate('cart.promo_code_invalid');
      case 'This coupon code could not be applied to the cart at this time.':
        return translate('cart.promo_code_unknown_error');
      default:
        return error;
    }
  };

  return (
    <>
      <ToggleButton
        showCode={showPromoCode}
        toggleShowCode={() => setShowPromoCode((prev) => !prev)}
        label="Apply Promo Code"
      />
      <AnimatePresence>
        {showPromoCode && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            sx={{ width: '100%' }}
          >
            <RedemptionForm
              forwardSx={forwardSx}
              onSubmit={handleSubmit}
              inputLabel={translate('cart.promo_code')}
              buttonText={translate('cart.apply_promo_code_button')}
              disabled={!!promotions.some((p) => p.code)}
              getErrorMessage={getErrorMessage}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default PromoCode;
